import { TodoStatus as GraphqlStatus } from "@acto/gql/graphql";

export default class TodoStatus {
  static OPEN = new TodoStatus("open");
  static COMPLETED = new TodoStatus("completed");
  static DELETED = new TodoStatus("deleted");
  #value: string;

  private constructor(value: string) {
    this.#value = value;
  }

  static fromGraphql(status: GraphqlStatus): TodoStatus {
    switch (status) {
      case GraphqlStatus.Open:
        return TodoStatus.OPEN;
      case GraphqlStatus.Completed:
        return TodoStatus.COMPLETED;
      case GraphqlStatus.Deleted:
        return TodoStatus.DELETED;
      default:
        throw new Error(`Unknown todo status: ${status}`);
    }
  }

  public toGraphql(): GraphqlStatus {
    switch (this.#value) {
      case "open":
        return GraphqlStatus.Open;
      case "completed":
        return GraphqlStatus.Completed;
      case "deleted":
        return GraphqlStatus.Deleted;
      default:
        throw new Error(`Unknown todo status: ${this.#value}`);
    }
  }

  public toString(): string {
    return this.#value;
  }

  public isOpen(): boolean {
    return this === TodoStatus.OPEN;
  }

  public isCompleted(): boolean {
    return this === TodoStatus.COMPLETED;
  }
}
